<template>
  <section>
    <v-toolbar color="white" class="box-shadow">
      <v-btn color="primary" class="box-shadow" @click="setToday">Today</v-btn>
      <v-spacer/>
      <v-btn text @click="$refs.workingHoursCalendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title class="mx-3">
        {{ $moment(this.focus).format('MMMM YYYY') }}
      </v-toolbar-title>
      <v-btn text @click="$refs.workingHoursCalendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer/>

      <v-toolbar-items style="height: auto">
        <v-select
            v-model="type"
            :items="type_options"
            item-text="label"
            item-value="value"
            menu-props="auto"
            hide-details
            single-line
            outlined
            dense
        ></v-select>
      </v-toolbar-items>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-calendar ref="workingHoursCalendar"
                    :now="today"
                    :type="type"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    @click:more="viewMore"
                    @click:date="viewMore"
                    @click:day="viewMore"
                    @change="loadEvents"
        >
        </v-calendar>
      </v-card>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    tutor: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    load_options: null,
    type: 'month',
    type_options: [
      { value: 'month', label: 'Month'},
      { value: 'week', label: 'Week'},
      { value: 'day', label: 'Day'},
    ],
    today: '',
    focus: '',
    event_items: [],
    repeat_options: [
      {text: 'Do not repeat', value: 'no_repeat'},
      // {text: 'Daily (Every day)', value: 'daily'},
      // {text: 'Weekday (Mon to Fri)', value: 'weekday'},
      {text: 'Repeat weekly', value: 'weekly'},
      // {text: 'Monthly (This day in every month)', value: 'monthly'},
    ],
    create_item_dialog: false,
    create_item: null,
    item_type_options: [
      {text: 'Available', value: 'available'},
      {text: 'Busy', value: 'busy'},
    ],
    selected_item: null,
    selected_item_dialog: false,
  }),
  computed: {
    events: function () {
      let items = []
      if(this.event_items && this.event_items.length > 0) {
        let mapped_items = this.event_items.map(item => ({...item, name: item.time_start + ' - ' + item.time_end}))
        items.push(...mapped_items)
      }
      return items
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  methods: {
    loadEvents({start, end}) {
      this.load_options = {start, end}
      this.axios.get(`api/tutors/${this.$route.params.tutor_id}/working-hours`, {
        params: {date_from: start.date, date_to: end.date}
      })
          .then(({data}) => { this.event_items = data.data })
    },
    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    viewMore({date}) {
      this.focus = date
      this.type = 'day'
    },
    // getEventColor(session) {
    //   return session.color ? session.color : 'primary'
    // },
    getEventColor(event) {
      let diff = this.$moment(event.end).diff(this.$currentTime().format())
      return diff > 0 ? 'primary' : 'secondary'
    },
  }
}
</script>